import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Logo from "../../assets/Swalokrbg.png";

const ClientSidebar = ({ userDetails }) => {
  const [collapsed, setCollapsed] = useState(false);
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.clear();
    navigate("/");
    window.location.reload();
  };

  const toggleSidebar = () => {
    setCollapsed(!collapsed);
  };

  return (
    <section className={`dashboard-sidebar ${collapsed ? "collapsed" : ""}`}>
      <div className="text-center overflow-y-auto">
        <img src={Logo} className="sidebar-logo mb-4" alt="sidebar logo" />

        <p className="sidebar-btn" onClick={() => navigate("/user/dashboard")}>
          <i className="fa-solid fa-house"></i> Dashboard
        </p>
        <p className="sidebar-btn" onClick={() => navigate("/user/profile")}>
          <i className="fa-solid fa-user"></i> Manage Profile
        </p>
        {userDetails.category !== "Associate" && (
          <>
            <p
              className="sidebar-btn"
              onClick={() => navigate("/user/add-report")}
            >
              <i className="fa-solid fa-file-text"></i> Add Report
            </p>
            <p
              className="sidebar-btn"
              onClick={() => navigate("/user/reports")}
            >
              <i className="fa-solid fa-clipboard"></i> View Reports
            </p>
          </>
        )}
        <p className="sidebar-btn" onClick={() => navigate("/user/team")}>
          <i className="fa-solid fa-users"></i> View Team
        </p>
        <p
          className="sidebar-btn"
          onClick={() => navigate("/user/plot-inventory")}
        >
          <i className="fa-solid fa-rectangle-list"></i> Plot Inventory
        </p>
        {/* <p className="sidebar-btn" onClick={() => navigate("/user/meeting")}>
            <i className="fa-solid fa-calendar-check"></i> Meetings
          </p> */}
        <p
          className="sidebar-btn"
          onClick={() => navigate("/user/sale-history")}
        >
          <i className="fa-solid fa-clock-rotate-left"></i> Sale History
        </p>
        <p
          className="sidebar-btn"
          onClick={() => navigate("/user/reward-history")}
        >
          <i className="fa-solid fa-gift"></i> Rewards History
        </p>
        <p className="sidebar-btn" onClick={() => navigate("/user/milestone")}>
          <i className="fa-solid fa-award"></i> Milestone
        </p>
        <p className="sidebar-btn" onClick={() => navigate("/user/salary")}>
          <i className="fa-solid fa-credit-card"></i> Salary
        </p>
        <p className="sidebar-btn" onClick={handleLogout}>
          <i className="fa-solid fa-right-from-bracket"></i> Logout
        </p>
      </div>

      <button className="w-auto sidebar-btn2 float-end" onClick={toggleSidebar}>
        <i
          className={`fa-solid ${
            collapsed ? "fa-angle-left" : "fa-angle-right"
          }`}
        ></i>
      </button>
    </section>
  );
};

export default ClientSidebar;
